import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    private customSwal = Swal.mixin({
        showCloseButton: true,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary',
        },
    });

    public openSuccessNotification(title: string, text: string) {
        return this.customSwal.fire({
            icon: 'success',
            timer: 60000,
            text,
            title,
        });
    }

    public openSuccessNotificationHTML(title: string, html: string) {
        return this.customSwal.fire({
            icon: 'success',
            timer: 60000,
            html,
            title,
        });
    }

    public openInfoNotificationConfirm(title: string, text: string, confirmButtonText: string) {
        return this.customSwal.fire({
            icon: 'info',
            allowOutsideClick: false,
            title,
            text,
            confirmButtonText,
        });
    }
    public openInfoNotificationConfirmHtml(title: string, html: string, confirmButtonText: string) {
        return this.customSwal.fire({
            icon: 'info',
            allowOutsideClick: false,
            title,
            html,
            confirmButtonText,
        });
    }
    public openInfoNotification(title: string, text: string) {
        return this.customSwal.fire({
            icon: 'info',
            timer: 60000,
            title,
            text,
        });
    }
    public openInfoNotificationHtml(title: string, html: string) {
        return this.customSwal.fire({
            icon: 'info',
            timer: 60000,
            title,
            html,
        });
    }
    public openWarningNotification(title: string, text: string) {
        return this.customSwal.fire({
            icon: 'warning',
            timer: 60000,
            title,
            text,
        });
    }
    public openWarningNotificationHtml(title: string, html: string) {
        return this.customSwal.fire({
            icon: 'warning',
            timer: 60000,
            title,
            html,
        });
    }
    public openDangerNotification(title: string, text: string) {
        return this.customSwal.fire({
            icon: 'error',
            timer: 60000,
            title,
            text,
        });
    }
    public openDangerNotificationHtml(title: string, html: string) {
        return this.customSwal.fire({
            icon: 'error',
            timer: 60000,
            title,
            html,
        });
    }
    public openConfirmNotification(title: string, text: string, showCancelButton: boolean = false, confirmButtonText: string = 'Aceptar', cancelButtonText: string = 'Cancelar', reverseButtons: boolean = false) {
        return this.customSwal.fire({
            icon: 'question',
            showCancelButton: true,
            confirmButtonText,
            cancelButtonText,
            title,
            text,
        });
    }

    public openRegisterBlockedNotification(): Promise<{ action: 'review' | 'exit' }> {
        return this.customSwal
            .fire({
                html: `
                <div class="register-blocked-swal">

                    <div class="rb-icon-wrapper" aria-hidden="true">
                        <div class="rb-icon-circle">
                            <svg viewBox="0 0 24 24" class="rb-doc-icon">
                                <path d="M6 2h8l4 4v16H6z" fill="none" stroke="currentColor" stroke-width="1.5"/>
                                <line x1="9" y1="8" x2="15" y2="8" stroke="currentColor" stroke-width="1.5"/>
                                <line x1="9" y1="12" x2="15" y2="12" stroke="currentColor" stroke-width="1.5"/>
                                <line x1="9" y1="16" x2="13" y2="16" stroke="currentColor" stroke-width="1.5"/>
                            </svg>
                            <span class="rb-error-badge">
                                <svg viewBox="0 0 24 24">
                                    <line x1="6" y1="6" x2="18" y2="18" stroke="white" stroke-width="2.5"/>
                                    <line x1="18" y1="6" x2="6" y2="18" stroke="white" stroke-width="2.5"/>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <h2 class="rb-title">No es posible completar tu registro</h2>

                    <div class="rb-description">
                        <p>Para crear una cuenta en Impulso Cultural, es necesario aceptar las autorizaciones y condiciones requeridas para el <strong>registro y uso</strong> de la plataforma.</p>
                        <p>Al no aceptar estas condiciones, <strong>no podremos continuar</strong> con la creación de tu cuenta.</p>
                        <p>Si deseas hacer parte del <strong class="rb-highlight">ecosistema cultural, artístico y patrimonial</strong>, puedes regresar y revisar nuevamente las condiciones antes de otorgar tu autorización.</p>
                    </div>
                </div>
            `,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: '→ Salir del registro',
                cancelButtonText: '← Volver y revisar',
                reverseButtons: true,
                allowOutsideClick: false,
                focusCancel: true,
                customClass: {
                    popup: 'rb-swal-popup',
                    confirmButton: 'btn rb-btn-filled',
                    cancelButton: 'btn rb-btn-outline',
                    htmlContainer: 'rb-swal-html',
                },
            })
            .then((result) => ({
                action: result.isConfirmed ? 'exit' : 'review',
            }));
    }
}
